/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.uploadImage

import features.uploadImage.UploadImageApi
import features.uploadImage.models.ImagesResponseModel
import features.uploadImage.serializeUploadImageState
import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlinx.serialization.json.Json
import kotlin.js.Promise

/**
 * upload an image [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UploadImageApi")
class UploadImageApiJs {

    /**
     * upload an image
     */


    
    fun uploadImage(overrideHeaders: String?,
serializedUploadImageBodyRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = UploadImageApi().uploadImage(
            overrideHeaders = decodedOverrideHeaders,
                uploadImageBodyRequest = Json.decodeFromString(
                    serializedUploadImageBodyRequest
                )
            ).toJsonResult<ImagesResponseModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeUploadImageState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UploadImageApi().uploadImageState.serializeUploadImageState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
